import React, { useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { useToast } from "../hooks/use-toast";
import { brand } from "../mock";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast({ title: "Please enter name & phone" }); return; }
    setSending(true);
    try {
      const res = await axios.post(`${API}/contact`, form);
      toast({ title: "Message sent!", description: res.data.message });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast({ title: "Failed to send", description: "Please try again." }); } finally { setSending(false); }
  };

  const info = [
    { icon: MapPin, label: "Address", value: brand.address },
    { icon: Phone, label: "Phone", value: brand.phone },
    { icon: Mail, label: "Email", value: brand.email },
    { icon: Clock, label: "Working Hours", value: brand.hours },
  ];

  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-6xl mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <p className="text-primary font-semibold tracking-wide uppercase text-sm">Get in Touch</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Contact Us</h1>
        <div className="w-20 h-1 bg-accent rounded-full mt-4" />

        <div className="grid lg:grid-cols-2 gap-8 mt-10">
          <div className="space-y-4">
            {info.map((i) => (
              <div key={i.label} className="flex items-start gap-4 bg-white rounded-2xl ring-1 ring-black/5 shadow-sm p-5">
                <div className="w-11 h-11 rounded-xl bg-secondary text-primary flex items-center justify-center shrink-0"><i.icon className="w-5 h-5" /></div>
                <div><div className="text-sm text-gray-500">{i.label}</div><div className="font-semibold text-gray-900">{i.value}</div></div>
              </div>
            ))}
          </div>

          <form onSubmit={submit} className="bg-white rounded-2xl ring-1 ring-black/5 shadow-sm p-6 space-y-4">
            <h2 className="font-display text-xl font-bold text-gray-900">Send us a message</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label>Name *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div className="space-y-1.5"><Label>Phone *</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            </div>
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Message</Label><Textarea rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="How can we help you?" /></div>
            <Button type="submit" disabled={sending} className="w-full bg-primary hover:bg-primary/90 h-11"><Send className="w-4 h-4 mr-1.5" /> {sending ? "Sending..." : "Send Message"}</Button>
          </form>
        </div>
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default Contact;
